module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog-edit-properties",
    attrs: {
      "visible": _vm.visible,
      "size": "large",
      "before-close": _vm.exit
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "ui grid two columns stackable"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("房间物品")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.property,
      "unstackable": "unstackable",
      "data": _vm.room_properties,
      "layout": "editing",
      "actions": "add minus remove",
      "pagesize": 15
    },
    on: {
      "action:add": _vm.item_add,
      "action:minus": _vm.item_minus,
      "action:remove": _vm.removeProp
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('h3', [_vm._v("库存物品")]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.property,
      "unstackable": "unstackable",
      "data": _vm.all_properties,
      "left-actions": "moveleft",
      "pagesize": 15
    },
    on: {
      "action:moveleft": _vm.moveleft
    }
  })], 1)]), _c('div', {
    staticClass: "ui field actions"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a81bda9","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/DialogEditProperties.vue
// module id = 370
// module chunks = 0